export const SERVER_ERROR = 'Opps, something went wrong. Please try again later.';
